// import {
//   SUBSCRIPTION_CREATE_ACTIONS,
//   SUBSCRIPTION_LIST_ACTIONS,
//   SUBSCRIPTION_EDIT_ACTIONS,
//   SUBSCRIPTION_DELETE_ACTIONS,
// } from "../../../actionsType";
// import { ADMIN_SUBSCRIPTION_ACTIONS } from "../../../actionsType/admin/subscription";

import { ADMIN_SUBSCRIPTION_ACTIONS } from "../../../actionType/admin/subscription";

const intialState = {
  subscriptionCreatData: {},
  isSubscriptionCreatLoader: false,
  subscriptionList: [],
  isSubscriptionListLoader: false,
  subscriptionDeleteLoader: false,
  subscriptionDeleteData: {},
};

export const adminSubscriptionReducer = (
  state = intialState,
  { type, payload }: any
) => {
  switch (type) {
    case ADMIN_SUBSCRIPTION_ACTIONS.SUBSCRIPTION_REQUEST:
      return { ...state, isSubscriptionCreatLoader: true };
    case ADMIN_SUBSCRIPTION_ACTIONS.SUBSCRIPTION_RESPONSE:
      return {
        ...state,
        subscriptionCreatData: payload,
        isSubscriptionCreatLoader: false,
      };
    case ADMIN_SUBSCRIPTION_ACTIONS.SUBSCRIPTION_ERROR:
      return {
        ...state,
        subscriptionCreatData: payload,
        isSubscriptionCreatLoader: false,
      };

    // SUBSCRIPTION_LIST_ACTIONS

    case ADMIN_SUBSCRIPTION_ACTIONS.SUBSCRIPTION_LIST_REQUEST:
      return { ...state, isSubscriptionListLoader: true };
    case ADMIN_SUBSCRIPTION_ACTIONS.SUBSCRIPTION_RESPONSE:
      return {
        ...state,
        subscriptionList: payload,
        isSubscriptionListLoader: false,
      };
    case ADMIN_SUBSCRIPTION_ACTIONS.SUBSCRIPTION_LIST_RESPONSE:
      return {
        ...state,
        subscriptionList: payload,
        isSubscriptionListLoader: false,
      };

    // SUBSCRIPTION_EDIT_ACTIONS

    case ADMIN_SUBSCRIPTION_ACTIONS.SUBSCRIPTION_EDIT_REQUEST:
      return { ...state, isSubscriptionCreatLoader: true };
    case ADMIN_SUBSCRIPTION_ACTIONS.SUBSCRIPTION_EDIT_RESPONSE:
      return {
        ...state,
        subscriptionCreatData: payload,
        isSubscriptionCreatLoader: false,
      };
    case ADMIN_SUBSCRIPTION_ACTIONS.SUBSCRIPTION_EDIT_ERROR:
      return {
        ...state,
        subscriptionCreatData: payload,
        isSubscriptionCreatLoader: false,
      };
    // SUBSCRIPTION_DELETE_ACTIONS

    case ADMIN_SUBSCRIPTION_ACTIONS.SUBSCRIPTION_DELETE_REQUEST:
      return { ...state, subscriptionDeleteLoader: true };
    case ADMIN_SUBSCRIPTION_ACTIONS.SUBSCRIPTION_DELETE_REQUEST:
      return {
        ...state,
        subscriptionDeleteData: payload,
        subscriptionDeleteLoader: false,
      };
    case ADMIN_SUBSCRIPTION_ACTIONS.SUBSCRIPTION_DELETE_ERROR:
      return {
        ...state,
        subscriptionDeleteData: payload,
        subscriptionDeleteLoader: false,
      };
    default:
      return state;
  }
};
